import React from "react";

export default class NavBarBurger extends React.Component {
  render() {
    let classes = "navbar-burger burger has-text-white";
    const {hamburgerIsActive, handleClick} = this.props;

    if (hamburgerIsActive) {
      classes += " is-active";
    }

    return (
      <div
        onClick={handleClick}
        onKeyPress={handleClick}
        role="button"
        tabIndex={0}
        className={classes}
        data-target="navBar"
      >
        <span />
        <span />
        <span />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavBar/burger.jsx